export class User {

    constructor(
        public id: number,
        public first_name: string,
        public last_name: string,
        public email: string,
        public avatar: string) {


    }

    getUserId() {
        if (this.id) {
            return this.id;
        }
        return null;
    }


}
